import { render, staticRenderFns } from "./PartCkuPrvsPopupDSearch.vue?vue&type=template&id=2c711ce1&"
import script from "./PartCkuPrvsPopupDSearch.vue?vue&type=script&lang=js&"
export * from "./PartCkuPrvsPopupDSearch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports